import {
	Caregiver,
	PurposeOfInvolvement,
	RelationshipKey,
	normalizeRelationship,
} from "../../entities/caregiver.model";

export class PtCaregiversInfoForm {
	data: PtCaregiverInfo[];

	constructor(params: Caregiver[]) {
		this.data = params.map((x) => new PtCaregiverInfo(x));
	}
}

export class PtCaregiverInfo {
	id: number | null;
	patientId: number;
	name: string | null;
	email: string | null;
	phone: string | null;
	relationship: RelationshipKey | null;
	purposeOfInvolvement: PurposeOfInvolvement[];
	sendHealthSummaryReport: boolean;
	deleted: boolean;
	createdOn: string | null;
	updatedOn: string | null;
	deletedOn: string | null;

	constructor(params: Partial<Caregiver>) {
		this.id = params.id ?? null;
		this.patientId = params.patientId!;
		this.name = params.name ?? null;
		this.email = params.email ?? null;
		this.phone = params.phone ?? null;
		this.relationship = normalizeRelationship(params.relationship);
		this.purposeOfInvolvement =
			params.purposeOfInvolvement ?? new Array<PurposeOfInvolvement>();
		this.sendHealthSummaryReport = params.sendHealthSummaryReport ?? false;
		this.deleted = params.deleted ?? false;
		this.createdOn = params.createdOn ?? null;
		this.updatedOn = params.updatedOn ?? null;
		this.deletedOn = params.deletedOn ?? null;
	}
}
